import React from 'react';
import ReferenceGenerator from '../../../components/ReferenceGenerator';
import { ENTERPRISE_ACTIVITY_TYPES_URL } from '../../../constants/urls';

export default function EnterpriseActivityTypeReferencePage() {
  return (
    <ReferenceGenerator url={ENTERPRISE_ACTIVITY_TYPES_URL} />
  );
}
